<template>
  <div
    class="psui-el-card-infos"
    role="button"
    tabindex="0"
    :aria-label="`View details for ${title} ${subtitle}`"
    @click="onClick()"
    @keyup.enter="onClick()"
  >
    <span class="psui-el-card-infos-title">
      <span :class="[titleClass, 'psui-mr-1']">{{ title }}</span>
      <slot name="subtitle">
        <span :class="subtitleClass">{{ subtitle }}</span>
      </slot>
    </span>
    <div class="psui-el-card-infos-content">
      <span class="psui-el-card-infos-icon material-icons-round">{{ icon }}</span>
      <span :class="totalClass">
        {{ total }}
      </span>
    </div>
  </div>
</template>

<script setup>

const emit = defineEmits(['click'])

defineProps({
  title: {
    type: String,
    default: 'Total',
  },
  /**
   * It sets the subtitle of your card if needed.
   */
  subtitle: {
    type: String,
    default: '',
  },
  /**
   * It sets the text key to get the svg icon in Google Fonts. Make sure to get the right description of your icon on https://fonts.google.com/.
   */
  icon: {
    type: String,
    default: 'edit',
  },
  /**
   * It sets the data that will show up when component is mounted.
   */
  total: {
    type: String,
    default: '',
  },
  /**
   * It sets the class for the title text (color, font-weight, font-size, etc.).
   */
  titleClass: {
    type: String,
    default: 'psui-text-gray-80 psui-font-bold',
  },
  /**
   * It sets the class for the subtitle text (color, font-weight, font-size, etc.).
   */
  subtitleClass: {
    type: String,
    default: 'psui-text-gray-80',
  },
  /**
   * It sets the class for the total text (color, font-weight, font-size, etc.).
   */
  totalClass: {
    type: String,
    default: 'psui-text-gray-80',
  },
})

const onClick = () => {
  emit('click')
}
</script>

<style>
/* Please, use the file src/assets/scss/components/PsCardInfos.scss */
</style>
